export default "__VITE_ASSET__DjuZ1abQ__"